import React from "react";
import TagsEditSingle from "./TagsEditSingle";
import TagsEditAllSearch from "./TagsEditAllSearch";
import TagsEditMany from "./TagsEditMany";
import { Sort, Selections } from "../../../modules/search/@types";

type TagsModalChooserProps = {
  hashes: string[] | [];
  isSelectAll: boolean;
  sort?: Sort;
  selections?: Selections;
  query?: string;
  handleShow: () => boolean;
  selectedCountTotalOverLimit?: boolean;
  mixedSamplesInSelection?: boolean;
  isSearchPage?: boolean;
};

const TagsModalChooser = ({
  hashes = [],
  isSelectAll,
  sort,
  selections,
  query = "",
  handleShow,
  selectedCountTotalOverLimit,
  mixedSamplesInSelection,
  isSearchPage = true
}: TagsModalChooserProps) => {
  if (hashes.length === 1) {
    const sampleHash = hashes[0];
    return <TagsEditSingle hash={sampleHash} show handleShow={handleShow} />;
  } else if (isSelectAll && (sort || selections || query) && isSearchPage) {
    return (
      <TagsEditAllSearch
        show
        handleShow={handleShow}
        sort={sort}
        selections={selections}
        query={query}
      />
    );
  } else {
    return (
      <TagsEditMany
        hashes={hashes}
        show
        handleShow={handleShow}
        selectedCountTotalOverLimit={selectedCountTotalOverLimit}
        mixedSamplesInSelection={mixedSamplesInSelection}
      />
    );
  }
};

export default TagsModalChooser;
